import React, { useState, useEffect } from 'react';
import styles from './sendBulkEmailsToCandidatesModal.module.scss';
import { Container, Col, Modal, Button, Row, } from 'react-bootstrap';
import EmailReview from './emailReview';
import EmailDetails from './emailDetails';
import CSSLoader from '../../../shared/cssLoader';
import { CustomButton } from '../../../shared/customButton';
import { getCandidateBulkEmailConfig } from '../../../../services/util/hiringpipeline/candidates';
import { sendBulkEmailsToCandidates } from '../../../../services/util/common/sendBulkEmailsToCandidates';
import { checkCompanyEmailAccountConnection } from '../../../../services/util/company';
import { CustomAlertBox } from '../../../shared/customAlertBox';

function SendBulkEmailsToCandidates(props) {
    let [isUserRoleAdmin, setUserRoleAdmin] = useState(false);
    let [step, setStep] = useState(1);
    let [emailData, setEmailData] = useState({
        templateWrapper: '',
        templateBody: '',
        email_subject: '',
        email_account_choice: null
    })
    let [isLoading, setLoading] = useState(false);
    let [submissionLoading, setSubmissionLoading] = useState(false);

    let [candidateEmailList, setCandidateEmailList] = useState([]);
    let [candidateIDList, setCandidateIDList] = useState([]);
    let [showEmailConnectModal, setShowEmailConnectModal] = useState(false);
    let [showEmailModal, setShowEmailModal] = useState(false);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function redirectToCompanySettings() {
        window.location.replace('/app/company/settings/integrations')
    }

    const onSubmitEmailData = (values) => {
        setEmailData((prevState) => ({
            ...prevState,
            templateBody: values.emailBody,
            email_subject: values.emailSubject

        }));
        nextPage(2);
    }

    const checkCompanyEmailConnected = async () => {
        setLoading(true);
        let respond = await checkCompanyEmailAccountConnection();
        if (respond.success === true) {
            if (respond.data.user_role_admin) {
                setUserRoleAdmin(true);
            }
            if (respond.data.is_company_ready_for_email_automation) {
                getInitialValues();
            } else {
                setShowEmailConnectModal(true);
                setLoading(false);
            }
        } else {
        }
    }

    const getInitialValues = async () => {
        let respond = await getCandidateBulkEmailConfig();
        if (respond.success === true) {
            setEmailData(respond.data);
            let candidate_email_list = [];
            let candidate_id_list = [];
            for (let index = 0; index < (props.candidateData).length; index++) {
                const candidate_email = (props.candidateData)[index].candidate_email;
                const candidate_id = (props.candidateData)[index].candidate_id;
                candidate_email_list.push(candidate_email);
                candidate_id_list.push(candidate_id);
            }
            setCandidateEmailList(candidate_email_list);
            setCandidateIDList(candidate_id_list)
            setShowEmailModal(true);
            setLoading(false);
        } else {
            setShowEmailModal(true);
            setLoading(false);
        }
    }

    const submitEmailTemplateValues = async () => {
        setSubmissionLoading(true);
        let respond = await sendBulkEmailsToCandidates(candidateIDList, emailData.email_subject, emailData.templateBody);
        if (respond.success === true) {
            setSubmissionLoading(false);
            props.handleClose();
            props.loadPageData();
        } else {
            setSubmissionLoading(false);
        }
    }

    useEffect(() => {
        checkCompanyEmailConnected();
    }, []);

    return (
        (<div>

            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    {isLoading === false ?
                        (<>
                            {/* email connect alert */}
                            {showEmailConnectModal && < div className={styles.modalBody}>
                                <div className={styles.popUpBoxTopicDiv}>
                                    <p className={styles.popUpBoxTopic}>Connect Company Email</p>
                                </div>
                                <Container>
                                    <Col>
                                        <p className={styles.popUpBoxMessage}>Company email haven't configured.</p>
                                    </Col>
                                    <Col>
                                        <p className={styles.popUpBoxMessageDesc}>Before sending email, connect one of your organization’s Google or Office 365 Email Accounts (ex :- careers@companyxxx.com). </p>
                                    </Col>
                                    {!isUserRoleAdmin && (
                                        <Row>
                                            <Col>
                                                <CustomAlertBox
                                                    alertBodyText="You don't have permission. Only admin users can connect the email account."
                                                    alertType="warningAlert"
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    <Container>
                                        <Row>
                                            <Col className="mb-2">
                                                <CustomButton
                                                    name="respondAcceptBtn"
                                                    buttonType="button"
                                                    type="defaultBtn"
                                                    label="Cancel"
                                                    handleClick={(() => setShowEmailConnectModal(false)) && (props.handleClose)}
                                                />
                                            </Col>
                                            <Col>
                                                <CustomButton
                                                    name="respondAcceptBtn"
                                                    disabled={isUserRoleAdmin ? false : true}
                                                    buttonType="button"
                                                    type="primaryBtn"
                                                    label="Connect Email"
                                                    handleClick={redirectToCompanySettings}
                                                />
                                            </Col>
                                        </Row>
                                    </Container>

                                </Container>
                            </div>}

                            {/* send email*/}
                            {showEmailModal && <>
                                <div className={styles.modalCancelBtnDiv}>
                                    <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                </div>

                                <div className={styles.modalHeaderDiv}>
                                    <h2 className={styles.modalHeader}>Send Email</h2>
                                </div>

                                <Col className={styles.stepPosition}>
                                    <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                                        <div className={styles.stepActive}>
                                            {
                                                step === 1 ?
                                                    <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g id="Content">
                                                            <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                            <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                        </g>
                                                    </svg>
                                                    :
                                                    <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_613_29628)">
                                                            <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_613_29628">
                                                                <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                            }

                                        </div>
                                        <div className={step === 2 ? styles.stepActive : ''}>
                                            {
                                                step === 2 ?
                                                    <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g id="Content">
                                                            <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                            <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                        </g>
                                                    </svg>
                                                    :
                                                    (step === 2) ?
                                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_613_29628)">
                                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_613_29628">
                                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        :
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_613_29582)">
                                                                <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                                <circle cx="12" cy="12" r="4" fill="#EAECF0" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_613_29582">
                                                                    <rect width="24" height="24" rx="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                            }
                                        </div>
                                    </div>
                                </Col>

                                <Col >
                                    {step === 1 && props.showModal === true && <EmailDetails onSubmitEmailData={onSubmitEmailData} closeModal={props.handleClose} emailData={emailData} candidateEmail={candidateEmailList} />}
                                    {step === 2 && props.showModal === true && <EmailReview previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} emailData={emailData} candidateEmail={candidateEmailList} submitEmailTemplateValues={submitEmailTemplateValues} submissionLoading={submissionLoading} />}
                                </Col>
                            </>}
                        </>)
                        :
                        (<div className='mt-5'>
                            <Col sm={{ span: 4, offset: 4 }}>
                                <CSSLoader />
                            </Col>
                        </div>)
                    }
                </Modal.Body>
            </Modal>

        </div>)
    )
}

export default SendBulkEmailsToCandidates;
